(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-mg-collection]').forEach(root => {
      if (root.dataset.mgReady) return;
      root.dataset.mgReady = 'true';
      const toggle = root.querySelector('[data-mg-filter-toggle]');
      const filters = root.querySelector('[data-mg-filters]');
      if (toggle && filters) {
        filters.hidden = true;
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          filters.hidden = !expanded;
        });
        filters.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            filters.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            toggle.focus();
          }
        });
      }
      const sortForm = root.querySelector('[data-mg-sort]');
      if (sortForm) {
        sortForm.querySelector('button[type="submit"]').hidden = true;
        sortForm.querySelector('select').addEventListener('change', event => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      }
      if (filters) filters.addEventListener('submit', event => {
        event.preventDefault();
        const url = new URL(window.location.href);
        for (const key of [...url.searchParams.keys()]) {
          if (key.startsWith('filter.') || key === 'page' || key === 'sort_by') url.searchParams.delete(key);
        }
        for (const [key,value] of new FormData(filters)) if (String(value).trim()) url.searchParams.append(key,value);
        window.location.assign(url.toString());
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
